import React from 'react';
import style from './style.module.scss';
import { iframe, data, div } from 'framer-motion/client';
export const VideosList = ({ arr }) => {
  console.log(arr, 'arr');

  const getEmbedUrl = (url?: string) => {
    if (!url) return '';
    return url.replace('/video/', '/play/embed/');
  };

  return (
    <div className={style.list}>
      {arr.map((elem : any, index : number) => {
        return (
          <div key={index} className={style.item}>
            <iframe
                className={style.video}
              src={getEmbedUrl(elem?.link)}
              allow="clipboard-write; autoplay"
              //@ts-ignore
              webkitAllowFullScreen
              mozallowfullscreen
              allowFullScreen
            />
          </div>
        );
      })}
    </div>
  );
};
